import React from 'react'
import BookButton from '../../Shared/BookButton';
import Access from '../../../img/Access.png'
import Login from '../../../img/Login.png'
import Payment from '../../../img/Payment.png'
import Select from '../../../img/Select.png'


// responsive


export default function Working() {
    return (
        // margin
        <div className='grid md:grid-cols-2 gap-8 p-20 sm:grid-cols-1'>
            <div className='grid grid-rows-2 ' >
                <div className='text-left'>
                    <h1 className='text-5xl md:text-7xl font-bold '>How it works</h1>
                    <h2 className='text-lg md:text-lg font-medium '>
                        Resolve all your confusions, problems
                        and mysteries of Career planning &
                        Career guidance
                    </h2>

                </div>
                <div className='w-fit'>
                    <BookButton name="Take a trial session" />
                </div>
            </div>

            <div className='grid grid-cols-2 '>
                <Buttons
                    image={Login}
                    title='1. Register/Login'
                    Detail='Fill details & select a Ranker of your choice.'
                />

                <Buttons
                    image={Select}
                    title='2. Select Plan'
                    Detail='Select the plan of your course and proceed.'
                />

                <Buttons
                    image={Payment}
                    title='3. Make a Payment'
                    Detail='Choose a payment method & click pay now.'
                />

                <Buttons
                    image={Access}
                    title='4. Access ABHAY Program'
                    Detail='Our team will get in touch with you.'
                />
            </div>
        </div>


    )
}


function Buttons(props) {
    return (
        <button className='btn btn-ghost normal-case gap-4 h-full  hover:' >
            <div>
                <img className='w-full h-full md:w-24 mx-auto' src={props.image} alt='' />
                <h2 className='md:text-xl text-sm font-semibold'>{props.title}</h2>
                <p className='md:text-sm text-xs'>{props.Detail}</p>
            </div>

        </button>
    );
}